import { render, staticRenderFns } from "./ChangeTemplateFolderModal.vue?vue&type=template&id=36b78942"
import script from "./ChangeTemplateFolderModal.vue?vue&type=script&lang=js"
export * from "./ChangeTemplateFolderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36b78942')) {
      api.createRecord('36b78942', component.options)
    } else {
      api.reload('36b78942', component.options)
    }
    module.hot.accept("./ChangeTemplateFolderModal.vue?vue&type=template&id=36b78942", function () {
      api.rerender('36b78942', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/ChangeTemplateFolderModal.vue"
export default component.exports